<template>
  <div v-if="show" class="card-traffic">
    <div class="traffic_datepicker">
      <WrapDatePicker
          v-model="cur_date"
          type="datetime"
          :range="true"
          value_type="DD-MM-YYYY"
          :disabled_date="['- 6 month', 'now']"
      />

      <button class="mdi btn btn-info" @click.prevent="cur_month">
        {{ translate('cur_month') }}
      </button>

      <button class="mdi btn btn-info" @click.prevent="last_30_days">
        {{ translate('last_30_days') }}
      </button>

      <button class="mdi btn btn-info" @click.prevent="last_month">
        {{ translate('last_month') }}
      </button>
    </div>

    <div v-if="tr.length <= 1" style="height: 100%">
      <h1 style="text-align: center">
        {{ translate('no_data') }}
      </h1>
    </div>

    <div v-else ref="header" class="row response_table3">
      <table ref="tabl" style="display: table; height: auto" @scroll="scroll">
        <thead>
        <tr>
          <th rowspan="2" class="traffic_block">
            {{ translate('date.one') }}
          </th>
          <th v-for="(item, index) in th" :key="index" colspan="3" class="traffic_block">
            <span v-if="item.type === 0"> {{ item.name }}({{ translate('speed.MB') }})</span>
            <span v-else>
                {{ item.imsi + ' ' + (item.slot ? '(' + item.slot + ')' : '') }}({{ translate('speed.MB') }})
                <span class="sphere" :class="(+item.active === 1 ? 'green' : 'red')" />
              </span>
          </th>
        </tr>
        <tr>
          <template v-for="(item, key) in th">
            <th :key="key + 'rx'">
              rx
            </th>
            <th :key="key + 'tx'">
              tx
            </th>
            <th :key="key + 'sum'" class="traffic_block">
              sum
            </th>
          </template>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, indx2) in tr" :key="indx2">
          <td v-for="(item2, index) in item" :key="index" :class="{ traffic_block: (index % 3 === 0) }">
            {{ item2 }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div v-else style="height: 100%">
    <div class="spinner">
      <scale-loader />
    </div>
  </div>
</template>

<script>


import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: 'SimcardTraffic',
  components: {WrapDatePicker},
  props: {
    sim_id: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    let today = new Date().setHours(0, 0, 0, 0)
    let start = (new Date(today).setDate(new Date(today).getDate() - 6) / 1000)
    let end = (new Date(today).setHours(23, 59, 59, 0) / 1000)

    return {
      loading: false,
      show: false,
      th: [],
      tr: [],
      today: today,
      date_end: end,
      date_start: start,
      cur_date: [''+start,''+end],
    }
  },

  watch: {
    sim_id() {
      this.get_traffic()
    },
    cur_date () {
      if (this.cur_date.length > 1) {
        this.date_start = +this.cur_date[0]
        this.date_end = +this.cur_date[1]
        this.get_traffic()
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },

  mounted() {
    this.get_traffic()
  },

  computed:{
    datetime_picker(){
      return this.$store.getters.getDatetimePicker
    }
  },
  methods: {
    cur_month(){
      this.date_start = (new Date(this.today).setDate(1) / 1000)
      this.date_end = (new Date(this.today).setHours(23, 59, 59, 0) / 1000)
      this.cur_date = [''+this.date_start, ''+this.date_end]
    },

    last_30_days(){
      this.date_start = (new Date(this.today).setMonth(new Date(this.today).getMonth() - 1) / 1000)
      this.date_end = (new Date(this.today).setHours(23, 59, 59, 0) / 1000)
      this.cur_date = [''+this.date_start, ''+this.date_end]
    },

    last_month(){
      this.date_start = (new Date(this.today).setMonth(new Date(this.today).getMonth() - 1, 1) / 1000)
      let last_day_last_month = new Date(this.today).setMonth(new Date(this.today).getMonth(), 0)
      this.date_end = (new Date(last_day_last_month).setHours(23, 59, 59, 0) / 1000)
      this.cur_date = [''+this.date_start, ''+this.date_end]
    },

    scroll(event) {
      this.$refs.header.scrollTo(event.target.scrollLeft, 0)
    },

    get_traffic() {
      if (this.$route.name === 'simcard_profile_section') {
        this.show = false

        let params = {
          "start": +this.date_start,
          "end": +this.date_end
        }

        this.$http.v1.getSimcardTraffic(this.sim_id, params, (response) => {
          this.show = true
          let th = []
          let iface = []

          let name_iface = []

          for (let i in response.data.ifaces) {
            name_iface.push(i);
          }

          name_iface.sort();

          for (let i in name_iface) {
            response.data.ifaces[i] =
                th.push({ type: 0, name: name_iface[i] })
            iface.push(name_iface[i])
          }

          for (let i in response.data.simcards) {
            response.data.simcards[i].type = 1
            th.push(response.data.simcards[i])
            iface.push(i)
          }
          this.th = th

          let tr = []
          let tdDate = []
          let td = []

          let traffics = Object.keys(response.data.traffic).sort()

          for (var i in traffics) {
            td = []
            tdDate.push(traffics[i])
            td.push(traffics[i])
            for (let j in iface) {
              if ((response.data.traffic[traffics[i]] !== null && response.data.traffic[traffics[i]][iface[j]] !== undefined)) {
                td.push(+response.data.traffic[traffics[i]][iface[j]].rx)
                td.push(+response.data.traffic[traffics[i]][iface[j]].tx)
                td.push(+response.data.traffic[traffics[i]][iface[j]].sum)
              } else {
                td.push('null')
                td.push('null')
                td.push('null')
              }
            }
            tr.push(td)
          }
          this.tr = tr
        })
      }
    }
  }
}

</script>

<style lang='scss' scoped>
.scale-loader {
  height: 9px;
  width: 9px;
  margin: 4px;
}

.card-traffic{
  display: flex;
  flex-direction: column;
  overflow:hidden;
  height: 100%;

  .traffic_datepicker {
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin: 10px 0;

    & > *{
      flex: 1;
      margin: 5px;
    }

    .form-group{
      min-width: 250px;
    }

    .btn{
      height: 40px;
    }
  }
}

</style>
